import { render } from "./ColorInput.vue?vue&type=template&id=40bc5dca&scoped=true"
import script from "./ColorInput.vue?vue&type=script&lang=js"
export * from "./ColorInput.vue?vue&type=script&lang=js"

import "./ColorInput.vue?vue&type=style&index=0&id=40bc5dca&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40bc5dca"]])

export default __exports__